// Central content + configuration. Everything is placeholder-editable.

export const IMAGES = {
  // New enhanced hero — Jakarta Lamborghini, portrait orientation
  heroPortrait:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_market-mind-25/artifacts/0v1r8c8d_Hero.png",
  // Full square image — displayed WHOLE, no crop
  fullMoment:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_market-mind-25/artifacts/h5xwqe8r_Full%20image.webp",
  // Lessons — pre-cropped head-to-mid-body with watch
  lessonsPortrait:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_market-mind-25/artifacts/t6hnq159_dakka.jpg",
  // Success — kept in natural color
  successImage:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_market-mind-25/artifacts/yvoulyh1_dakka-2.jpg",
  // Lamborghini interior / steering wheel — focus & control
  steeringWheel:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_market-mind-25/artifacts/vqueh7ny_WhatsApp%20Image%202026-07-16%20at%208.45.00%20AM.webp",
  // Lamborghini Club Indonesia (night)
  lamboClub:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_market-mind-25/artifacts/vesh15o2_WhatsApp%20Image%202026-07-16%20at%208.33.26%20AM.jpeg",
  // Arsenal / Emirates stadium
  stadium:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_market-mind-25/artifacts/vr099969_WhatsApp%20Image%202026-07-16%20at%208.18.05%20AM%20%282%29.jpeg",
  lifestyleSupercars:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_ade55dcb-5af1-4b5b-8e2f-db8c0a0c4954/artifacts/vp7r380h_WhatsApp%20Image%202026-07-16%20at%208.12.07%20AM.webp",
  lifestyleFoodCourt:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_ade55dcb-5af1-4b5b-8e2f-db8c0a0c4954/artifacts/luq3oshh_WhatsApp%20Image%202026-07-16%20at%208.12.07%20AM%20%281%29.webp",
  lifestyleSelfie:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_ade55dcb-5af1-4b5b-8e2f-db8c0a0c4954/artifacts/l1n0denu_WhatsApp%20Image%202026-07-16%20at%208.14.20%20AM.webp",
  detailFerrari:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_ade55dcb-5af1-4b5b-8e2f-db8c0a0c4954/artifacts/5ue6pdqv_WhatsApp%20Image%202026-07-16%20at%208.17.14%20AM.jpeg",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Journey", href: "#journey" },
  { label: "Trading", href: "#trading" },
  { label: "Values", href: "#values" },
  { label: "Insights", href: "#insights" },
  { label: "Contact", href: "#contact" },
];

export const SOCIALS = [
  { label: "Instagram", href: "#", handle: "@dakkagabrielrey" },
  { label: "LinkedIn", href: "#", handle: "Dakka Gabriel Rey" },
  { label: "YouTube", href: "#", handle: "Dakka Gabriel Rey" },
  { label: "Email", href: "mailto:hello@dakkagabrielrey.com", handle: "hello@dakkagabrielrey.com" },
];

export const JOURNEY = [
  {
    no: "01",
    title: "Curiosity",
    text: "Discovering financial markets and developing an interest in how money, psychology, and global events shape opportunities.",
  },
  {
    no: "02",
    title: "Learning",
    text: "Building knowledge through study, observation, practice, mistakes, and continuous evaluation.",
  },
  {
    no: "03",
    title: "Transformation",
    text: "Understanding that long-term performance requires emotional maturity, discipline, and personal change.",
  },
  {
    no: "04",
    title: "Clarity",
    text: "Developing a more structured approach to markets, decisions, priorities, and life.",
  },
  {
    no: "05",
    title: "Purpose",
    text: "Sharing insights and experiences that may help others think more critically about trading and personal growth.",
  },
];

export const PHILOSOPHY = [
  {
    icon: "BookOpen",
    title: "Knowledge Before Action",
    text: "Decisions should be supported by research, preparation, and a clear understanding of risk.",
  },
  {
    icon: "Brain",
    title: "Discipline Over Emotion",
    text: "Sustainable results come from following a process rather than reacting impulsively.",
  },
  {
    icon: "ShieldCheck",
    title: "Risk Is Part of the Game",
    text: "The objective is not to eliminate uncertainty, but to manage it intelligently.",
  },
  {
    icon: "TrendingUp",
    title: "Progress Over Perfection",
    text: "Every trade, decision, and mistake can become part of a stronger long-term strategy.",
  },
];

export const VALUES = [
  "Integrity",
  "Discipline",
  "Patience",
  "Responsibility",
  "Humility",
  "Consistency",
  "Adaptability",
  "Lifelong Learning",
];

export const LESSONS = [
  {
    no: "01",
    title: "Selective Attention",
    text: "Not every opportunity deserves a reaction.",
  },
  {
    no: "02",
    title: "Protect The Downside",
    text: "Protecting your downside is as important as pursuing growth.",
  },
  {
    no: "03",
    title: "Emotional Clarity",
    text: "Emotional clarity improves decision quality.",
  },
  {
    no: "04",
    title: "Quiet Consistency",
    text: "Consistency creates stronger results than temporary intensity.",
  },
  {
    no: "05",
    title: "Accountability",
    text: "Real transformation begins when accountability replaces excuses.",
  },
];

export const INSIGHTS = [
  {
    category: "Psychology",
    title: "The Psychology Behind Better Trading Decisions",
    description:
      "How self-awareness and emotional regulation quietly separate reactive traders from deliberate ones.",
    readingTime: "6 min read",
    href: "#",
  },
  {
    category: "Mindset",
    title: "What Financial Markets Teach Us About Patience",
    description:
      "Markets reward those who can wait — a lesson that reshapes how we approach almost everything.",
    readingTime: "5 min read",
    href: "#",
  },
  {
    category: "Discipline",
    title: "Why Personal Discipline Matters More Than Motivation",
    description:
      "Motivation fades. Systems, habits, and discipline are what carry performance across time.",
    readingTime: "7 min read",
    href: "#",
  },
];

export const DISCLAIMER =
  "The information presented on this website is intended for educational and informational purposes only. It does not constitute financial, investment, or trading advice. Trading and investing involve risk, and past performance does not guarantee future results.";
